define('modules/start/view',['require','exports','module','i18n','env','views/BaseView','./companySelector/view','./dashboard/view','./products/index','./groupCPSAgreementsModal/view','ThemesHelper','ldsh!./template'],function (require, exports, module) {
  'use strict';

  var i18n = require('i18n'),
      Config = require('env'),
      BaseView = require('views/BaseView'),
      CompanySelectorView = require('./companySelector/view'),
      DashboardView = require('./dashboard/view'),
      Products = require('./products/index'),
      GroupCPSAgreementsModal = require('./groupCPSAgreementsModal/view'),
      ThemesHelper = require('ThemesHelper');

  var Layout = BaseView.extend({
    template: require('ldsh!./template'),

    isCPSAccepted: function () {
      if (
          Config.CPSAgreements.canBeDelayed && (
              ThemesHelper.getCookie(Config.CPSAgreements.cookieDismissName) ===
              Config.CPSAgreements.cookieDismissValue
          )
      ) {
        return true;
      }

      if (this.group.isCPSAgreementsAccepted()) {
        return true;
      }

      return false;
    },

    beforeRender: function () {
      if (!this.isCPSAccepted()) {
        this.printCPSModal();
        return;
      }

      this.insertAccountSelector();

      if (this.products.groupHasService('MDirector')) {
        this.insertDashboard();
      }

      if (!this.products.isRequest && !this.productsReport.isRequest) {
        this.insertProducts();
      }
    },

    initialize: function () {
      if (this.mdDetailsModel) {
        this.listenTo(this.mdDetailsModel, 'sync request error', this.render);
      }

      if (this.products) {
        this.listenTo(this.products, 'sync request error', this.render);
      }

      if (this.productsReport) {
        this.listenTo(this.productsReport, 'sync request error', this.render);
      }
    },

    getUserName: function () {
      var suffix = ' (' + this.me.get('GROUP_ID') + ')',
          name = this.me.get('NAME')[0],
          lastName = this.me.get('LASTNAME')[0];

      if (name === lastName) {
        return name + suffix;
      }

      return name + ' ' + lastName + suffix;
    },

    serialize: function () {
      return {
        me: this.me,
        products: this.products,
        productsReport: this.productsReport,
        isGroupCPSAgreementsAccepted: this.isCPSAccepted(),
        userName: this.getUserName(),
      };
    },

    insertAccountSelector: function () {
      this.insertView('#products-company-selector', new CompanySelectorView({
        me: this.me,
        group: this.group,
        products: this.products,
        productsReport: this.productsReport
      }));
    },

    insertDashboard: function () {
      this.insertView('#products-dashboard', new DashboardView({
        group: this.group,
        products: this.products,
        productsReport: this.productsReport
      }));
    },

    insertProducts: function () {
      var viewParams = {
        me: this.me,
        group: this.group,
        products: this.products,
        productsReport: this.productsReport,
        modules: Products.Modules,
        mdDetailsModel: this.mdDetailsModel
      };

      this.insertView('#products-list', new Products.View(viewParams));
    },

    printCPSModal: function () {
      this.insertView('#products-list', new GroupCPSAgreementsModal({
        me: this.me,
        model: this.group
      }));
    },
  });

  module.exports = Layout;
});

